import {
  AccountsApi,
  Configuration,
  ContactPersonsApi,
  ContractorsApi,
  DictionaryItemsApi,
  DocumentsApi,
  ExamsApi,
  ExamTypesApi,
  FailuresApi,
  FailureStatusApi,
  FailureTasksApi,
  FailureTypesApi,
  ImagesApi,
  InformationApi,
  InventoryApi,
  InventoryCategoryApi,
  MaintenanceApi,
  OptionsApi,
  RepairmenApi,
  ReportApi,
  RolePermissionsApi,
  SpecialPlacesApi,
  TownsApi,
  UserApi,
  WorkbooksApi,
} from "api/generated/lumen";
import { DevicesApi } from "./generated/lumen/apis/DevicesApi";
import { errorHandlingMiddleware } from "./middleware/errorHandlingMiddleware";
import {
  requestHeadersMiddleware,
  unauthenticatedRequestHeadersMiddleware,
} from "./middleware/requestHeadersMiddleware";

const apiConfig: Configuration = new Configuration({
  basePath: process.env.REACT_APP_API_URL,
  middleware: [...errorHandlingMiddleware, ...requestHeadersMiddleware],
});

const unauthenticatedApiConfig: Configuration = new Configuration({
  basePath: process.env.REACT_APP_API_URL,
  middleware: [
    ...errorHandlingMiddleware,
    ...unauthenticatedRequestHeadersMiddleware,
  ],
});

export const api = {
  lumen: {
    failures: new FailuresApi(apiConfig),
    failureTypes: new FailureTypesApi(apiConfig),
    towns: new TownsApi(apiConfig),
    dictionaryItems: new DictionaryItemsApi(apiConfig),
    inventory: new InventoryApi(apiConfig),
    contractors: new ContractorsApi(apiConfig),
    repairmen: new RepairmenApi(apiConfig),
    accounts: new AccountsApi(apiConfig),
    documents: new DocumentsApi(apiConfig),
    workbooks: new WorkbooksApi(apiConfig),
    contactPerson: new ContactPersonsApi(apiConfig),
    maintenance: new MaintenanceApi(apiConfig),
    images: new ImagesApi(apiConfig),
    information: new InformationApi(apiConfig),
    devices: new DevicesApi(apiConfig),
    failureTask: new FailureTasksApi(apiConfig),
    inventoryCategory: new InventoryCategoryApi(apiConfig),
    specialPlaces: new SpecialPlacesApi(apiConfig),
    examTypes: new ExamTypesApi(apiConfig),
    exams: new ExamsApi(apiConfig),
    report: new ReportApi(apiConfig),
    options: new OptionsApi(apiConfig),
    rolePermissions: new RolePermissionsApi(apiConfig),
    users: new UserApi(apiConfig),
    failureStatus: new FailureStatusApi(apiConfig),

    unauthenticated: {
      failures: new FailuresApi(unauthenticatedApiConfig),
      failureTypes: new FailureTypesApi(unauthenticatedApiConfig),
    },
  },
};
